import React from 'react';
import { Loader } from '@keen.io/ui-core';
import { Container } from './widget-loader.styles';
var WidgetLoader = function () { return (React.createElement(Container, null,
    React.createElement(Loader, { height: 40, width: 40 }))); };
export default WidgetLoader;
